var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPlusIco = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26.93 26.93",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-plus-1{fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "plus_ico"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hero_cw",
    "data-name": "hero cw"
  }, /*#__PURE__*/React.createElement("g", {
    id: "M_330-floating-buttons-S_option-1-2",
    "data-name": "M 330-floating-buttons-S option-1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    className: "cls-plus-1",
    d: "M12.12,12.12V0h2.69V12.12H26.93v2.69H14.81V26.93H12.12V14.81H0V12.12Z"
  }))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPlusIco, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/plus_ico.c1ed7ab3.svg";
export { ForwardRef as ReactComponent };